import type { VNode } from 'vue';

import { cva } from 'class-variance-authority';

import CharacteristicsGrid from './Grid.vue';

export { default as RangeLabel } from './RangeLabel.vue';

export { CharacteristicsGrid };

export interface CharacteristicItem {
	title?: string;
	value: string;
	icon: any;
	iconClass?: string;
	isLink?: boolean;
	linkTo?: string;
	class?: string;
}

export interface CharacteristicsGridProps {
	isLoading?: boolean;
	characteristics: CharacteristicItem[];
}

export type Characteristic = {
	label: string | VNode;
	description?: string | VNode;
	icon: Component;
};

export const rangeLabelVariants = cva(
	'text-base font-medium leading-[26px] text-primary',
	{
		variants: {
			variant: {
				default: '',
				light: 'text-primary-light-2'
			},
			size: {
				base: 'text-base',
				xs: 'text-xs',
				sm: 'text-sm md:text-base',
				xl: 'text-lg md:text-xl'
			}
		},
		defaultVariants: {
			variant: 'default',
			size: 'base'
		}
	}
);
